import React, { useState } from "react";
import AnimateCC from "../../../animate";
import { MC } from "../../../animate/utils";
import { PreloaderComponent } from "../../../loaders/PreloaderComponent";
import { DiffrencesBasic } from "../../DifferencesBasic";

const SucotGameComponent: React.FC<{}> = () => {
    const game = React.useRef(new DiffrencesBasic());
    const directLink = new URLSearchParams(window.location.search).get("path");
    const [fromDirectLink] = useState(directLink);
    const [screenReady, setScreenReady] = useState(false);

    return (
        <>
            {fromDirectLink && !screenReady && <PreloaderComponent name="plain" />}
            <AnimateCC
                base="/special_games/sucot"
                animationName="sucot"
                onLoaded={(mc: MC) => {
                    setScreenReady(true);
                    game.current.loaded(mc, "sucot");
                }}
            />
        </>
    );
};
export default SucotGameComponent;
